




























































































































import { Vue, Component } from 'vue-property-decorator';
import AppModule from '@/store/modules/app';
import LifecycleModule from '@/store/modules/lifecycle';
import { getLoginErrorMessage } from '@/util/AuthUtil';
import Card from '@/components/Card/StandardCard/index.vue';
import SiteLayout from '../../layout/fw/index.vue';
import Textfield from '../../components/Form/Textfield/index.vue';
import PrimaryButton from '../../components/Buttons/PrimaryButton/index.vue';

@Component({
  beforeRouteEnter(to, from, next) {
    if (AppModule.isLoggedIn) {
      next({ name: 'home', replace: true });
    } else {
      next();
    }
  },
  components: {
    SiteLayout,
    Card,
    Textfield,
    PrimaryButton,
  },
})
export default class LoginView extends Vue {
  private username: string = '';

  private password: string = '';

  private error: string = '';

  private loading: boolean = false;

  private viewablePassword: boolean = false;

  private alert: boolean = false;

  get canSignIn() {
    return this.password.length >= 1 && this.username.length >= 1;
  }

  get passwordStateIcon() {
    if (this.viewablePassword) {
      return 'mdi-eye-off';
    }
    return 'mdi-eye';
  }

  public togglePasswordView() {
    this.viewablePassword = !this.viewablePassword;
  }

  public clearLoginError() {
    this.error = '';
  }

  public async signIn() {
    this.error = '';
    try {
      this.loading = true;
      await AppModule.authenticate({
        username: this.username.trim(),
        password: this.password,
      });
      await LifecycleModule.init();
      if (this.$router.app.$route.query && this.$router.app.$route.query.redirect) {
        this.$router.push(this.$router.app.$route.query.redirect as string);
      } else {
        this.$router.push('/home');
      }
    } catch (err) {
      this.error = getLoginErrorMessage(err);
    }
    this.loading = false;
  }
}
